/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as MsDyn365 from '@msdyn365-commerce/core';

import * as React from 'react';

import { IEcommNotifBannerData } from './ecomm-notif-banner.data';
import { IEcommNotifBannerProps } from './ecomm-notif-banner.props.autogenerated';

export interface IEcommNotifBannerViewProps extends IEcommNotifBannerProps<IEcommNotifBannerData> {
    title: string;
    description: React.ReactNode;
}

/**
 *
 * EcommNotifBanner component
 * @extends {React.PureComponent<IEcommNotifBannerProps<IEcommNotifBannerData>>}
 */
class EcommNotifBanner extends React.PureComponent<IEcommNotifBannerProps<IEcommNotifBannerData>> {
    public render(): JSX.Element | null {
        const { config } = this.props;

        const text = config.description && <MsDyn365.RichTextComponent text={config.description} editProps={{onEdit: this._handleTextChange, requestContext:this.props.context.request}} />;

        const EcommNotifBannerViewProp = {
            ...this.props,
            title: config.title,
            description: text
        };

        return this.props.renderView(EcommNotifBannerViewProp);
    }

    private _handleTextChange = (event: MsDyn365.ContentEditableEvent) => this.props.config.description = event.target.value;
}

export default EcommNotifBanner;
